import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useQuickLinksPanelStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
    ...shorthands.padding('0.75rem'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    boxShadow: tokens.shadow4,
    [mq.mobile]: {
      ...shorthands.padding('0.625rem'),
      ...shorthands.borderRadius('0.75rem'),
    },
  },
  /**
   * Figma 2026 right-rail variant (node `1-444` / `1-713`): white card with
   * neutral 1 px border, 8 px radius, soft shadow only on hover.
   */
  rootFigma: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingHorizontalL),
    boxShadow: 'none',
    position: 'sticky',
    top: tokens.spacingVerticalL,
  },
  title: {
    fontSize: fontScale.body,
    fontWeight: '600',
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.43em',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0.5rem',
    listStyleType: 'none',
    ...shorthands.margin('0'),
    ...shorthands.padding('0'),
  },
  linkItem: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '0.5rem',
    ...shorthands.padding('0.25rem', '0.5rem'),
    ...shorthands.borderRadius('0.2188rem'),
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  linkIcon: {
    display: 'flex',
    alignItems: 'center',
    color: tokens.colorNeutralForeground3,
    flexShrink: 0,
  },
  link: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground2,
    textDecorationLine: 'none',
    lineHeight: '1.43em',
    ':hover': {
      textDecorationLine: 'underline',
      color: tokens.colorBrandForeground1,
    },
  },
});
